import { connect } from 'react-redux';

import CardHeader from 'components/dashboard/CardHeader';
import { getLiveParams } from "selectors/liveParams";

const LIVE_PARAMS = ['err', 'power', 'rpm_rotor', 'state', 'kwh_meter', 'timestamp'];

// windTurbine can be momentarily undefined during navigation between two
// turbines' detail pages - see components/dashboard/CardHeader.js's guard
// for the crash this caused ("Cannot read properties of undefined
// (reading 'name')", no error boundary to catch it, whole page went
// blank). mapStateToProps runs on every store update, so this needs the
// same guard.
const mapStateToProps = (state, ownProps) => {
  const windTurbineId = ownProps.windTurbine && ownProps.windTurbine.id;
  return {
    liveProps: getLiveParams(state, windTurbineId, LIVE_PARAMS),
    turbineState: state.turbineState[windTurbineId],
    // 'all', not added to LIVE_PARAMS: a param list fills missing keys with
    // 0, which would read as status_word 0 (CCI down) for non-PF2 turbines.
    cciDsoProps: getLiveParams(state, windTurbineId, 'all'),
  };
};

export default connect(mapStateToProps)(CardHeader);
